import Image from "next/image"
import React, { FunctionComponent } from "react"
import useDevice from "hooks/useDevice"
type Props = {
  onClick: () => void
  alignment?: "left" | "center"
}
const HeaderLogo: FunctionComponent<Props> = ({
  onClick,
  alignment = "center",
}) => {
  const { isMobile } = useDevice()
  return (
    <div className="fixed top-0 left-0 w-full z-[998]" onClick={onClick}>
      <div
        className={`py-4 border-b border-[#DBDBDB] shadow-2 bg-white w-full flex ${
          alignment === "left" ? "pl-[148px] justify-start" : "justify-center"
        }`}
      >
        <Image
          src={`${process.env.CDN_URL}/assets/company_logo/new-header-logo.svg`}
          height={isMobile ? 24 : 37}
          width={isMobile ? 120 : 191}
          alt="leap-scholar-logo"
        />
      </div>
    </div>
  )
}
export default HeaderLogo
